import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['yesRadio', 'noRadio', 'urlField'];
  static values = { hasUrl: Boolean };

  connect() {
    if (this.yesRadioTarget.checked || (this.hasUrlValue && !this.noRadioTarget.checked)) {
      this.yesRadioTarget.checked = true;
      this.#show();
    }
  }

  toggle(event) {
    if (event.target.value === 'yes') {
      this.#show();
    } else {
      this.#hide();
    }
  }

  #show() {
    this.urlFieldTarget.classList.remove('hidden');
  }

  #hide() {
    this.urlFieldTarget.classList.add('hidden');
  }
}
